
export * from '../../frontend-taglib-clay/__liferay__/exports/@clayui$empty-state.js';

import __default__ from '../../frontend-taglib-clay/__liferay__/exports/@clayui$empty-state.js';
export default __default__;
